import ListMap from '../core/ListMap';
import Link from './Link';
import {findConnection} from "../libs";

class LinkList extends ListMap {
  constructor(args = {}) {
    const {
      data = {},
    } = args;

    const linkList = Object.entries(data)
      .filter(v => !!v[1])
      .map(v => new Link({ ...args,
        data: {
          name: v[0],
          url: v[1],
        },
      }));

    super({ ...args, data: linkList });

    // This must be called for every List implementation.
    this.list().map(v => v.parent(this));
  }

  constructItem(key) {
    return new Link({ data: { name: key } });
  }

  connection() {
    return findConnection(this.parent());
  }


  export() {
    const links = {};
    this.itemList.forEach((v) => {
      links[v.attr('name')] = v.attr('url');
    });

    return links;
  }
}

export default LinkList;
